import { Component, OnInit } from '@angular/core';
import { AnalysisMessages } from '../../../shared/models/component-messages/analysis-messages';
import { VerificationMessages } from '../../../shared/models/component-messages/verification-messages';
import { UploaderMessages } from '../../../shared/models/component-messages/uploader-messages';
import { VerificationService } from '../../services/verification.service';
import { VerificationSession } from '../../services/verification-session.service';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../shared/services/spinner.service';
import { ShowOrHideSpinner } from '../../../shared/models/showOrHideSpinner';
import { VerificationResponseData } from '../../../../models/verification-response-data';
import { ApiErrorCode } from '../../../shared/models/apiErrorCode';
import { VerificationRequestData } from 'src/app/models/verification-request-data';
import { environment } from 'src/environments/environment';
import { LogService } from 'src/app/modules/shared/services/log.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent extends ShowOrHideSpinner implements OnInit {

  public isPending: boolean;
  public validationMessage = '';
  public isValid = true;
  public filesToUpload: Array<any> = [];
  public errorSize: string;
  public errorLength: string;

  public analysisMessage = new AnalysisMessages();
  public verificationMessages = new VerificationMessages();
  public uploaderMessages = new UploaderMessages();

  public profile = environment.profile;

  public isSigned = false;
  public verificationErrors = ['NO_SIGNATURE_FOUND', 'CORRUPTED_DOCUMENT', 'INVALID_FILE_EXTENSION'];
  public verificationFiles = {
    originalFile: null,
    signedDocument: null
  };

  constructor(private verificationService: VerificationService, private verificationSession: VerificationSession, private router: Router,
              private spinnerService: SpinnerService, private LOG: LogService) {
    super();
  }

  public ngOnInit() {
    this.errorSize = '';
    this.isPending = true;
    this.filesToUpload.push({
      name: 'uploader.upload.verify_sign_contract',
      fileType: 'signed',
      limitSize: 1,
      required: true,
      type: 'signed'
    });
    this.filesToUpload.push({
      name: 'uploader.upload.verify_sign_complementary',
      fileType: 'original',
      limitSize: 1,
      required: false,
      type: 'original'
    });
  }

  public async submitFiles() {
    if (this.allFilesSizeMoreThen20Mo()) {
      this.validationMessage = 'create_signature.file_max';
    } else {
      this.showSpinner(this.spinnerService);
      this.isPending = false;
      this.verificationSession.verificationResponseData = new VerificationResponseData();
      this.insertFilesToSession();
      this.verificationService.verify(this.verificationSession.verificationRequestData).subscribe(
        data => {
          this.clearErrors();
          this.hideSpinner(this.spinnerService);
          this.verificationSession.verificationResponseData = data;
          if (this.profile === 'tst' || this.profile === 'dev') {
            this.verificationService.dssReports(this.verificationSession.verificationResponseData.newReport.reportId)
              .subscribe(newReport => this.verificationSession.verificationResponseData.dssReports = newReport);
            if (this.verificationSession.verificationResponseData.previousReport) {
              this.verificationService.dssReports(this.verificationSession.verificationResponseData.previousReport.reportId)
                .subscribe(previousReport => this.verificationSession.verificationResponseData.previousDssReports = previousReport);
            }
          }
          this.isValid = true;
          this.router.navigate(
            ['/verifier/process', {
              outlets: {
                verification: ['resultat']
              }
            }]);
        },
        (error) => {
          if (this.router.url.includes('/verifier/process')) {
            if (!error.error || !this.verificationErrors.includes(error.error.errorCode)) {
              throw error;
            } else {
              this.isPending = true;
              this.validationMessage = ApiErrorCode[error.error.errorCode];
              this.isValid = false;
            }
          }
          this.hideSpinner(this.spinnerService);
        }
      );
    }
  }

  public resetFile() {
    if (document.getElementById('files-list') != null) {
      while (document.getElementById('files-list') != null) {
        document.getElementById('files-list').remove();
      }
    }
    this.verificationFiles.signedDocument = null;
    this.verificationFiles.originalFile = null;
    this.verificationSession.verificationRequestData = new VerificationRequestData();
    this.validationMessage = '';
    document.getElementById("input-file").focus()
    this.clearErrors();
    this.isPending = true;
  }

  public getValidationMessage(message) {
    if (message === '') {
      this.isValid = true;
      this.validationMessage = message;
      return;
    }
    this.validationMessage = message;
  }

  public getErrorSize(errorSize) {
    this.errorSize = errorSize;
  }

  public getErrorLength(errorLength) {
    this.errorLength = errorLength;
  }

  public isDisableButton(): boolean {
    return this.isVerificationDataSetted() && this.isSignedDocumentPresent();
  }

  public deleteFile(obj) {
    this.logParameters('Before', 'delete', obj);
    this.isPending = true;
    if (obj === 'original') {
      this.verificationFiles.originalFile = null;
    }
    if (obj === 'signed') {
      this.verificationFiles.signedDocument = null;
    }
    this.logParameters('After', 'delete', obj);
  }

  public uploadFile(obj) {
    this.logParameters('Before', 'upload', obj.fileType);
    this.isPending = true;
    if (obj.fileType === 'original') {
      this.verificationFiles.originalFile = obj.file;
    }
    if (obj.fileType === 'signed') {
      this.verificationFiles.signedDocument = obj.file;
    }
    this.logParameters('After', 'upload', obj.fileType);
  }

  private allFilesSizeMoreThen20Mo() {

    let size = 0;
    if (this.verificationSession.verificationRequestData.signedDocument) {
      size += this.verificationSession.verificationRequestData.signedDocument.size;
    }
    if (this.verificationSession.verificationRequestData.originalFile) {
      size += this.verificationSession.verificationRequestData.originalFile.size;
    }
    return (size / 1048576) > 20;
  }

  private clearErrors(): void {
    this.isValid = true;
    this.errorSize = '';
    this.errorLength = '';
  }

  private isVerificationDataSetted(): boolean {
    return !!this.verificationFiles;
  }

  private isSignedDocumentPresent(): boolean {
    return !!this.verificationFiles.signedDocument;
  }

  private logParameters(order, action, obj): void {
    const message = '[' + order + ' ' + action + ' of {0}]-[originalFile = {1} | signedFile = {2}]';
    this.LOG.log(message,
      obj,
      this.verificationFiles.originalFile ? this.verificationFiles.originalFile.name : '',
      this.verificationFiles.signedDocument ? this.verificationFiles.signedDocument.name : '');
  }


  private insertFilesToSession(): void {
    this.verificationSession.verificationRequestData = new VerificationRequestData();
    if (this.verificationFiles.originalFile && this.verificationFiles.signedDocument) {
      this.verificationSession.verificationRequestData.originalFile = this.verificationFiles.signedDocument;
      this.verificationSession.verificationRequestData.signedDocument = this.verificationFiles.originalFile;

    } else if (this.verificationFiles.signedDocument) {
      this.verificationSession.verificationRequestData.signedDocument = this.verificationFiles.signedDocument;
    }
  }
}
